import { render } from "./ThicknessMeasurementStatistic.vue?vue&type=template&id=8e4d38a6"
import script from "./ThicknessMeasurementStatistic.vue?vue&type=script&lang=js"
export * from "./ThicknessMeasurementStatistic.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__